module.exports = __webpack_public_path__ + "img/edit-box-blue.8483e6ad.svg";